<template>
  <div class="frameDragRoot" ref="frameDragRoot">
    <div @click.stop role="drag-rect-left-top" v-frame-drag-line="'left-top'"></div>
    <div @click.stop role="drag-rect-right-top" v-frame-drag-line="'right-top'"></div>
    <div @click.stop role="drag-rect-right-bottom" v-frame-drag-line="'right-bottom'"></div>
    <div @click.stop role="drag-rect-left-bottom" v-frame-drag-line="'left-bottom'"></div>

    <div @click.stop role="drag-line-left" v-frame-drag-line="'left'"></div>
    <div @click.stop role="drag-line-right" v-frame-drag-line="'right'"></div>
    <div @click.stop role="drag-line-top" v-frame-drag-line="'top'"></div>
    <div @click.stop role="drag-line-bottom" v-frame-drag-line="'bottom'"></div>
  </div>
</template>

<script>
//拖拽页面
export default {
  name: "imFrameDrag",
  props: {
    minWidth: {
      type: [Number,String],
      default:''
    },
    minHeight: {
      type: [Number,String],
      default:''
    },
    dragEl:{
      type:[String,Element],
      default:null
    }
  },
  watch:{
    dragEl:{
      handler(){
        this.$nextTick(()=>this.setDrag(this.dragEl))
      },
      immediate:true
    },
  },
  data() {
    return {
      mouseup: true,
      parentBoxWidth: 0,
      parentBoxHeight: 0,
    }
  },
  mounted() {
    if (!this.parentBoxWidth) {
      const parent = this.getParent()
      this.parentBoxWidth = parent.offsetWidth
      this.parentBoxHeight = parent.offsetHeight
    }
  },
  directives: {
    /**
     * 设置拖拽线（上下左右）和拖拽点（上左、上右、下左、下右）
     * @param el
     * @param binding
     * @param vnode
     */
    frameDragLine(el, binding, vnode) {
      const that = vnode.context
      const app = document.body
      const direction = binding.value
      el.onmousedown = () => {
        that.mouseup = false
        const parentBox = that.mousedownFun(app)
        const funList = []
        that.$emit('down')
        if (direction.includes('left')) {//左边
          funList.push((ev) => {
            const left = ev.clientX - parentBox.offsetLeft
            el.style.left = left - el.offsetWidth / 2 + 'px'
            let width = parentBox.offsetWidth - left
            if (width >= (that.minWidth || that.parentBoxWidth)) {
              parentBox.style.width = width + 'px'
              parentBox.style.left = ev.clientX + 'px'
            }
          })
        }
        if (direction.includes('right')) {//右边
          funList.push((ev) => {
            const width = ev.clientX - parentBox.offsetLeft
            el.style.left = width - el.offsetWidth / 2 + 'px'
            if (width >= (that.minWidth || that.parentBoxWidth)) {
              parentBox.style.width = width + 'px'
              parentBox.style.right = ev.clientX + 'px'
            }
          })
        }
        if (direction.includes('top')) {//上边
          funList.push((ev) => {
            const top = ev.clientY - parentBox.offsetTop
            el.style.top = top - el.offsetHeight / 2 + 'px'
            const height = parentBox.offsetHeight - top
            if (height >= (that.minHeight || that.parentBoxHeight)) {
              parentBox.style.height = height + 'px'
              parentBox.style.top = ev.clientY + 'px'
            }
          })
        }
        if (direction.includes('bottom')) {//下边
          funList.push((ev) => {
            const top = ev.clientY - parentBox.offsetTop
            el.style.top = top - el.offsetHeight / 2 + 'px'
            if (top >= (that.minHeight || that.parentBoxHeight)) {
              parentBox.style.height = top + 'px'
              parentBox.style.bottom = ev.clientY + 'px'
            }
          })
        }
        app.onmousemove = (ev) => {
          requestAnimationFrame(() => {
            if (!that.mouseup) {
              funList.forEach(fun => fun(ev))
              that.$emit('move')
            }
          })
        }
        const f =()=>{
          setTimeout(()=>{
            el.style.left = ''
            el.style.top = ''
          },50)
          that.mouseupFun(app)
          that.$emit('up')
          return false
        }
        el.onmouseup= () => {
         return f()
        }
        window.onmouseup = () => {
          f()
        }
      }
    }
  },
  methods: {
    /**
     * 设置按住后可以拖动的元素监听，设置后，按住可以拖动当前元素所在的窗口
     * @param el
     */
    setDrag(el){
      let element = el
      if (typeof el === 'string'){
        element = document.querySelector(el)
      }
      const app = document.body
      if (!(element instanceof Element))return
      element.onmousedown = (ev) => {
        this.mouseup = false
        const parentBox = this.mousedownFun(app)
        let offsetX = ev.clientX - parentBox.offsetLeft
        let offsetY = ev.clientY - parentBox.offsetTop
        this.$emit('down')
        app.onmousemove = (ev) => {
          requestAnimationFrame(() => {
            let x = ev.clientX - offsetX
            let y = ev.clientY - offsetY
            let xMax = (x > 0 && x < app.offsetWidth - parentBox.offsetWidth)
            let yMax = (y > 0 && y < app.offsetHeight - parentBox.offsetHeight)
            if (!this.mouseup && xMax && yMax) {
              parentBox.style.left = x + 'px'
              parentBox.style.top = y + 'px'
              this.$emit('move')
            }
          })
        }
        window.onmouseup = () => {
          this.mouseupFun(app)
          this.$emit('up')
        }
      }
    },
    /**
     * 抬起鼠标
     * @param app
     */
    mouseupFun(app) {
      window.onmouseup = null
      app.onmousemove = null
      app.style.userSelect = 'text'
      const parent = this.getParent()
      parent.style.transition = '0.3s all';

    },
    /**
     * 按下鼠标
     * @param app
     */
    mousedownFun(app) {
      app.style.userSelect = 'none'
      const parent = this.getParent()
      parent.style.transition = '0s all';
      return parent
    },
    /**
     * 获取父级元素
     * @returns {HTMLElement}
     */
    getParent(){
      return this.$refs.frameDragRoot.parentElement
    }
  }
}
</script>

<style scoped lang="scss">
.frameDragRoot {
  position: absolute;
  z-index: 9999;
  width: 100%;
  height: 100%;
  pointer-events: none;

  & > div {
    pointer-events: auto;
  }

  & > div[role^=drag-rect] {
    width: 10px;
    height: 10px;
    position: absolute;
    z-index: 6;
    //background: #00D9AE;
  }

  & > div[role=drag-rect-left-top] {
    left: -5px;
    top: -5px;
    cursor: nwse-resize;
  }

  & > div[role=drag-rect-right-top] {
    right: -5px;
    top: -5px;
    cursor: nesw-resize;
  }

  & > div[role=drag-rect-right-bottom] {
    right: -5px;
    top: calc(100% - 5px);
    cursor: nwse-resize;
  }

  & > div[role=drag-rect-left-bottom] {
    left: -5px;
    top: calc(100% - 5px);
    cursor: nesw-resize;
  }


  & > div[role^=drag-line] {
    position: absolute;
    z-index: 5;
    //background: #00aeff;
  }


  & > div[role=drag-line-left] {
    left: -5px;
    top: 5px;
    width: 10px;
    height: calc(100% - 10px);
    cursor: ew-resize;
  }

  & > div[role=drag-line-right] {
    right: -5px;
    top: 5px;
    width: 10px;
    height: calc(100% - 10px);
    cursor: ew-resize;
  }

  & > div[role=drag-line-top] {
    top: -5px;
    left: 5px;
    width: calc(100% - 10px);
    height: 10px;
    cursor: ns-resize;
  }

  & > div[role=drag-line-bottom] {
    left: 5px;
    bottom: -5px;
    width: calc(100% - 10px);
    height: 10px;
    cursor: ns-resize;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/teachingDetail/list/classroom/imcomponents/imFrameDrag.vue